const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 16/12/16.
 */
const React = require('react');
const {formatText} = require('core/i18n').i18n;
require('./PromotionalCode.scss');

class AddPromotionalCode extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                promotionalCode: '',
                component_id: 'promotionalCode',
                value:''
            };
        }
        this.state = initialState;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }


    handleBlur(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({promotionalCode: this.input.value});
    }

    render() {
        //this.props.dataReceiver(this.state);
        return (
            <div className="promotional-code">
                <form onSubmit={this.handleSubmit}>
                    <div>
                        <h4 className="contract-view__subtitle">{formatText('contractsView-checkingAccountPromotionalCodeTitle')}</h4>
                    </div>
                    <div>
                        <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                            <div className="ok-slider__text">{formatText('contractsView-checkingAccountPromotionalCodeAddCode')}</div>
                            <input type="text" defaultValue={this.state.promotionalCode} value={this.state.promotionalCode} onBlur={this.handleBlur} className="ok-input__input promotional-code__input"/>
                            <input type="submit" value="OK"  className="ok-default-button promotional-code__button"/>
                        </div>

                    </div>
                </form>
            </div>);
    }
}

AddPromotionalCode.propTypes = {
    values: PropTypes.any,
    dataReceiver: PropTypes.func
};

module.exports = AddPromotionalCode;